export default __webpack_public_path__ + "static/media/wave.2d4bbd84.png";